import React from 'react';

export default React.createContext({
  stateKey: 'form'
});

